import React, { useContext, useEffect, useRef, useState } from "react";
import "./Trade_Layout.css";

import Main_Chart_Section from "../trade_components/main_chart_section/Main_Chart_Section";
import Instruments from "../trade_components/instruments/Instruments";
import Right_End_Toolbar from "../trade_components/right_end_toolbar/Right_End_Toolbar";
import Portfolio from "../trade_components/main_chart_section/portfolio/Portfolio";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faWallet, faShoppingCart, faTimes } from "@fortawesome/free-solid-svg-icons";

import { Offcanvas } from "react-bootstrap";

import Deposit_Lottie from "../../animation/deposit_lottie/Deposit_Lottie";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Close_modal from "../../common_components/common_modal/close_modal/Close_modal";
import Delete_modal from "../../common_components/common_modal/delete_modal/Delete_modal";
import Close_Trade_Modal from "../../common_components/common_modal/close_trade_modal/Close_Trade_Modal";

import { getAllCompanyMarketPrice } from "../../../utils/apis/graph/graph";
import { getBelowGraphData } from "../../../utils/apis/below_graph_data/below_graph";

import { Context } from "../../../utils/context";
import { io } from "socket.io-client";

const Trade_Layout = () => {
  const { setHeaderCompanyName, signin, getuserData, userdata, SOCKET } = useContext(Context);

  // Modal States
  const [modalCloseShow, setModalCloseShow] = useState(false);
  const [modalCloseTradeShow, setModalCloseTradeShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Drawer States
  const [showInstruments, setShowInstruments] = useState(false);
  const [showOrderPanel, setShowOrderPanel] = useState(false);
  const [showPortfolio, setShowPortfolio] = useState(false);

  // Trade States
  const [activeBtn, setActiveBtn] = useState("Open");
  const [companyId, setCompanyId] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [latestAmount, setLatestAmount] = useState(0);
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [closeTradeId, setCloseTradeId] = useState("");

  // Data States
  const [priceHistory, setPriceHistory] = useState([]);
  const [latestCloses, setLatestCloses] = useState({});
  const [latestBaseCloses, setLatestBaseCloses] = useState({});
  const [belowGraphData, setBelowGraphData] = useState({});

  const socketRef = useRef(null);

  const getPriceHistory = async (search = "") => {
    const res = await getAllCompanyMarketPrice(search);
    if (res?.success && res.data.data.length > 0) {
      setPriceHistory(res.data.data);
      const first = res.data.data[0];
      setCompanyId(first.Company?.id || first.id);
      setCompanyName(first.Company?.name || first.name);
      setHeaderCompanyName(first.Company?.name || first.name);
    }
  };

  const getGraphData = async () => {
    if (signin && companyId) {
      const res = await getBelowGraphData(companyId, activeBtn);
      if (res?.success) setBelowGraphData(res.data);
    }
  };

  useEffect(() => {
    getPriceHistory();
  }, []);

  useEffect(() => {
    getGraphData();
  }, [companyId, activeBtn]);

  useEffect(() => {
    if (!priceHistory.length) return;

    if (!socketRef.current) {
      socketRef.current = io(SOCKET || process.env.REACT_APP_SOCKET_URL, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
      });
    }

    const socket = socketRef.current;

    const handleAnyEvent = (eventName, chartData) => {
      const companyIdNum = Number(eventName);
      if (isNaN(companyIdNum) || !chartData || chartData.length < 2) return;

      const last = chartData[chartData.length - 1];
      const prev = chartData[chartData.length - 2];

      const newClose = Math.max(0, Number(last.Close || 0));
      const prevClose = Math.max(0, Number(prev.Close || 0));

      setLatestCloses((p) => ({ ...p, [companyIdNum]: newClose }));
      setLatestBaseCloses((p) => ({ ...p, [companyIdNum]: prevClose }));

      if (companyIdNum === companyId) {
        setLatestAmount(newClose);
      }
    };

    socket.onAny(handleAnyEvent);

    return () => {
      socket.offAny(handleAnyEvent);
    };
  }, [priceHistory, companyId, SOCKET]);

  useEffect(() => {
    return () => {
      if (socketRef.current) socketRef.current.disconnect();
    };
  }, []);

  const onSelectStock = (id, name) => {
    setCompanyId(id);
    setCompanyName(name);
    setHeaderCompanyName(name);
  };

  return (
    <div className="h-screen w-full pb-16 bg-gray-950 text-white flex flex-col overflow-hidden relative">
      {/* Main Chart */}
      <div className="flex-1 pb-[env(safe-area-inset-bottom)] md:pb-0 relative">
        <Main_Chart_Section
          companyId={companyId}
          companyName={companyName}
          latestAmount={latestAmount}
          setLatestAmount={setLatestAmount}
          price={price}
          setPrice={setPrice}
          setQuantity={setQuantity}
          priceHistory={priceHistory}
          latestCloses={latestCloses}
          latestBaseCloses={latestBaseCloses}
          belowGraphData={belowGraphData}
          activeBtn={activeBtn}
          setActiveBtn={setActiveBtn}
          setCloseTradeId={setCloseTradeId}
          closeTradeId={closeTradeId}
          showClsoeModal={() => setModalCloseTradeShow(true)}
          showDeleteModal={() => setModalDeleteShow(true)}
        />
      </div>

      {/* Mobile Bottom Bar */}
      <div className="md:hidden fixed inset-x-0 bottom-0 bg-gray-900/95 backdrop-blur-2xl border-t border-gray-800 z-50 pb-[env(safe-area-inset-bottom)]">
        <div className="flex items-center justify-around py-2 px-4">
          <button onClick={() => setShowInstruments(true)} className="flex flex-col items-center gap-1.5 text-gray-400 hover:text-white">
            <FontAwesomeIcon icon={faChartLine} className="text-xl" />
            <span className="text-xs font-medium">Markets</span>
          </button>

          <button onClick={() => setShowPortfolio(true)} className="flex flex-col items-center gap-1.5 text-gray-400 hover:text-white">
            <FontAwesomeIcon icon={faWallet} className="text-xl" />
            <span className="text-xs font-medium">Portfolio</span>
          </button>

          <button onClick={() => setShowOrderPanel(true)} className="bg-[#029C81]  text-white font-bold text-sm px-6 py-2 rounded-xl shadow-2xl transition-all hover:scale-105 active:scale-95">
            BUY / SELL
            <div className="text-xs opacity-90 mt-0.5">${latestAmount.toFixed(2)}</div>
          </button>

          {/* <button onClick={() => setShowOrderPanel(true)} className="bg-[#ff4d4f] text-white font-bold text-lg px-10 py-4 rounded-2xl shadow-2xl transition-all hover:scale-105 active:scale-95">
            SELL
            <div className="text-xs opacity-90 mt-0.5">${latestAmount.toFixed(2)}</div>
          </button> */}
        </div>
      </div>

      {/* Desktop Floating Buttons */}
      <div className="hidden md:flex fixed left-8 bottom-8 flex-col gap-4 z-40">
        <button onClick={() => setShowInstruments(true)} className="w-14 h-14 bg-gray-800/80 backdrop-blur-md rounded-full flex items-center justify-center shadow-2xl hover:bg-gray-700 hover:scale-110 transition-all">
          <FontAwesomeIcon icon={faChartLine} className="text-xl" />
        </button>
        <button onClick={() => setShowPortfolio(true)} className="w-14 h-14 bg-gray-800/80 backdrop-blur-md rounded-full flex items-center justify-center shadow-2xl hover:bg-gray-700 hover:scale-110 transition-all">
          <FontAwesomeIcon icon={faWallet} className="text-xl" />
        </button>
      </div>

      <div className="hidden md:block fixed right-8 bottom-8 z-40">
        <button onClick={() => setShowOrderPanel(true)} className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-2xl hover:bg-blue-700 hover:scale-110 transition-all">
          <FontAwesomeIcon icon={faShoppingCart} className="text-2xl" />
        </button>
      </div>

      {/* MARKETS DRAWER - Custom Header with Visible Close Button */}
      <Offcanvas show={showInstruments} onHide={() => setShowInstruments(false)} placement="start" className="w-full max-w-sm !bg-gray-900/95 backdrop-blur-xl">
        <div className="border-b text-white border-gray-800 px-6 py-4  mt-14 max-md:-mb-14  flex items-center justify-between sticky top-0 bg-gray-900/95 backdrop-blur-xl z-10">
          <h2 className=" font-bold"></h2>
          <button
            onClick={() => setShowInstruments(false)}
            className="w-5 h-5 rounded-full bg-gray-800/50 hover:bg-gray-700 flex items-center justify-center transition-all"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} className="text-xl" />
          </button>
        </div>
        <Offcanvas.Body className="p-0">
          <Instruments
            priceHistory={priceHistory}
            selectedCompanyId={companyId}
            latestCloses={latestCloses}
            latestBaseCloses={latestBaseCloses}
            onSelect={onSelectStock}
            getPriceHistory={getPriceHistory}
            onClose={() => setShowInstruments(false)}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* ORDER PANEL - Custom Header with Visible Close Button */}
      <Offcanvas show={showOrderPanel} onHide={() => setShowOrderPanel(false)} placement="end" className="w-full max-w-md !bg-gray-900/95 backdrop-blur-xl">
        <div className="border-b text-white border-gray-800 px-6 pt-14 pb-2  mt-7  flex items-center justify-between sticky top-0 bg-gray-900/95 backdrop-blur-xl z-10">
          <h2 className="text-2xl font-bold"></h2>
          <button
            onClick={() => setShowOrderPanel(false)}
            className="w-5 h-5 rounded-full bg-gray-800/50 hover:bg-gray-700 flex items-center justify-center transition-all"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} className="text-xl" />
          </button>
        </div>
        <Offcanvas.Body className="p-0">
          <Right_End_Toolbar
            companyId={companyId}
            companyName={companyName}
            latestAmount={latestAmount}
            setPrice={setPrice}
            price={price}
            onClose={() => setShowOrderPanel(false)}
            openSuccess={() => setShowModal(true)}
            handlePageChange={getGraphData}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* PORTFOLIO BOTTOM SHEET - Already has good close button */}
      <Offcanvas show={showPortfolio} onHide={() => setShowPortfolio(false)} placement="bottom" className="!h-2/4 max-md:!h-[32%] !bg-gray-900/95 backdrop-blur-xl rounded-t-3xl">
        <Offcanvas.Header closeButton closeVariant="white" className="justify-center text-white pt-8 pb-2">
          {/* <div className="w-12 h-1.5 bg-gray-600 rounded-full mb-4" /> */}
          <Offcanvas.Title className="text-2xl font-bold">Portfolio</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 overflow-y-auto">
          <Portfolio
            belowGraphData={belowGraphData}
            latestAmount={latestAmount}
            activeBtn={activeBtn}
            setActiveBtn={setActiveBtn}
            showClsoeModal={() => setModalCloseTradeShow(true)}
            showDeleteModal={() => setModalDeleteShow(true)}
            setCloseTradeId={setCloseTradeId}
            setQuantity={setQuantity}
            onHide={() => setShowPortfolio(false)}
            getGraphData={getGraphData}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Modals remain unchanged */}
      {modalCloseTradeShow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setModalCloseTradeShow(false)} />
          <div className="relative z-10 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <Close_Trade_Modal
              getGraphData={getGraphData}
              show={modalCloseTradeShow}
              closeTradeId={closeTradeId}
              amount={latestAmount}
              latestAmount={latestAmount}
              quantity={quantity}
              onHide={() => setModalCloseTradeShow(false)}
              onSubmit={() => {
                setModalCloseTradeShow(false);
                setModalCloseShow(true);
              }}
            />
          </div>
        </div>
      )}

      {modalCloseShow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setModalCloseShow(false)} />
          <div className="relative z-10 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <Close_modal
              getGraphData={getGraphData}
              show={modalCloseShow}
              closeTradeId={closeTradeId}
              amount={latestAmount}
              onHide={() => setModalCloseShow(false)}
            />
          </div>
        </div>
      )}

      {modalDeleteShow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setModalDeleteShow(false)} />
          <div className="relative z-10 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <Delete_modal
              show={modalDeleteShow}
              closeTradeId={closeTradeId}
              amount={latestAmount}
              getGraphData={getGraphData}
              getuserData={getuserData}
              userdata={userdata}
              onHide={() => setModalDeleteShow(false)}
            />
          </div>
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShowModal(false)} />
          <div className="relative z-10 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <Successfull_Modal
              message="Trade Successful!"
              show={showModal}
              onHide={() => setShowModal(false)}
              lottie={<Deposit_Lottie />}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Trade_Layout;